export const fileTypeIcons = {
  doc: 'ic_doc',
  docx: 'ic_docx',
  pdf: 'ic_pdf',
  ppt: 'ic_ppt',
  pptx: 'ic_pptx',
  xls: 'ic_xls',
  xlsx: 'ic_xlsx',
};

// for reference: https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
// only list down general types for supporting in previewing
export const imgFileSupportTypes = [
  'apng',
  'avif',
  'gif',
  'jpg',
  'jpeg',
  'jfif',
  'png',
  // 'svg', // SVG isn't supported, see https://github.com/angular/angular/issues/18950
  'webp',
  'bmp',
];

export const getFileTypeIconByName = (fileName: string): string => {
  let ext = fileName.split('.').pop();

  // return image icons if it's in support list
  if (isImageFile(ext)) return 'ic_image';

  return fileTypeIcons[ext] ?? 'ic_document';
};

export const bytesToSize = (bytes: number): string => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i)) + sizes[i];
};

export const generateAttachmentTitle = (attachment: File): string => {
  const fileSize = bytesToSize(attachment.size);
  return `${attachment.name} (${fileSize})`;
};

export const isImageFile = (fileName: string): boolean => {
  let ext = fileName.split('.').pop();
  const idx = imgFileSupportTypes.findIndex(ele => {
    // make sure 'PNG' and 'png' will be treated equally
    return ele == ext.toLowerCase();
  });
  return idx > -1 ? true : false;
};
